import React, { PropTypes } from 'react';
import '../../styles/LoadingScreen';

let LoadingScreen = React.createClass({
	displayName: 'LoadingScreen',

	propTypes: {
		message: PropTypes.string
	},

	render: function() {
		return (
			<div className="loading-screen">
				<img src="/images/gear_spinner.svg" />
				<h3>
					{ this.props.message ? this.props.message : 'Loading' }
				</h3>
			</div>
		);
	}
});

module.exports = LoadingScreen;



// WEBPACK FOOTER //
// ./frontend/shared/js/components/LoadingScreen.jsx